import React from 'react';
import classnames from 'classnames';
import styles from './TwoFactor.module.scss';
import { Heading, Subtitle } from 'components/Text';
import Icon from 'components/Icon';
import { t, getTranslation } from 'components/Translate';
import Button from 'components/Button';
import Input from 'components/Input/Base';
import Alert from 'components/Alert';

type Props = {
  titleKey?: string | null,
  descriptionKey?: string,
  error?: string | null,
  onErrorDismiss?: () => void,
  isLoading?: boolean,
  isOverlaying?: boolean,
  hasIcon?: boolean,
  className?: string,
  onSubmit: (code: string) => void,
};
type State = {
  code: string,
};

class TwoFactor extends React.PureComponent<Required<Props>, State> {
  static defaultProps: OptionalProps<Props> = {
    titleKey: '2fa.title',
    descriptionKey: '2fa.desc',
    error: null,
    isLoading: false,
    isOverlaying: true,
    hasIcon: true,
  };
  state: State = {
    code: '',
  };

  private get isCorrect() {
    return !!this.state.code.length;
  }
  private submit = () => {
    if (!this.isCorrect || this.props.isLoading) return;

    this.props.onSubmit(this.state.code);
  };

  render() {
    const classes = classnames(styles.info, this.props.className, { [styles.overlaying]: this.props.isOverlaying });

    return (
      <div className={ classes }>
        { this.props.hasIcon &&
          <div className={ styles.icon }>
            <Icon.Normal name="lock" size="xx-large" />
          </div>
        }
        { this.props.titleKey !== null &&
          <Heading type="large">
            { t(this.props.titleKey) }
          </Heading>
        }
        <Subtitle color="dark-light">
          { t(this.props.descriptionKey) }
        </Subtitle>
        <div className={ styles.inputWrapper }>
          <Input
            placeholder={ getTranslation('2fa.placeholder') }
            value={ this.state.code }
            fullWidth={ true }
            size="large"
            onChange={ (code) => this.setState({ code }) }
            onEnter={ this.submit }
            attrs={ { autoFocus: true } }
          />
        </div>

        { !!this.props.error &&
          <Alert theme="error" onClose={ this.props.onErrorDismiss }>
            { this.props.error }
          </Alert>
        }

        <Button
          size="large"
          fullWidth={ true }
          disabled={ !this.isCorrect }
          isLoading={ this.props.isLoading }
          onClick={ this.submit }
        >
          { t('common.action.auth') }
        </Button>
      </div>
    );
  }
}

export default TwoFactor;



